import { render } from "./ELECTED_DURING_TERM.vue?vue&type=template&id=1e4e9562"
import script from "./ELECTED_DURING_TERM.vue?vue&type=script&lang=js"
export * from "./ELECTED_DURING_TERM.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__